module.exports = __webpack_public_path__ + "img/vol05_heading.da71728d.png";